<script lang="ts">
import Vue from 'vue'
import {createOrganizations} from "@/api/organizations/organizations"
import BaseModal from "@/components/ui/BaseModal.vue";
import modalMixin from "@/views/organizations/mixins/modalMixin";

export default Vue.extend({
    name: "AddRegionModal",
    components: {BaseModal},
    mixins: [modalMixin],
    data() {
        return {
            name: null,
        }
    },
    methods: {
        save() {
            const form = {
                name: this.name,
                parent_id: this.$store.getters.USER.organizationId,
                type: 'region'
            }

            createOrganizations(form).then(() => {
                this.visible = false
                this.name = null
                this.$emit('saved')
            })
        }
    }
})
</script>

<template>
    <div>
        <BaseModal v-model="visible">
            <div class="title">Додати дирекцію</div>
            <div class="row form-group mt-8">
                <div class="col-12">
                    <label>Назва</label>
                    <input type="text" class="form-control" v-model="name">
                </div>
            </div>
            <div class="row form-group mt-4">
                <div class="col">
                    <button type="button" class="btn btn-primary w-100" @click="save">Додати</button>
                </div>
            </div>
        </BaseModal>
    </div>
</template>

<style scoped lang="scss">
.title {
    font-family: Geist,serif;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    /* identical to box height, or 117% */
    text-align: center;

    color: #09090B;

    /* Inside auto layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    margin-bottom: 21px;
}
</style>
